module.exports = __webpack_public_path__ + "start-screen.svg?70ac3d0d2b0bdef8a43d82b61590d8c0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/start-screen.svg
// module id = 325
// module chunks = 2